var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root flex justify-between items-center"},[_c('p',{staticClass:"w-full",style:({height:_vm.height})},[_vm._t("default")],2),_vm._t("icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }